var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "发送消息",
        width: "760px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
        drag: _vm.drag,
        modal: false,
        "footer-text": ["发送", "取消"],
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "robotSend overflowOuto" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                size: "small",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择人员", prop: "senderType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.senderType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "senderType", $$v)
                        },
                        expression: "form.senderType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("学员")]),
                      _c("el-radio", { attrs: { label: 2, disabled: "" } }, [
                        _vm._v("数字人"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { prop: "robots" } }, [
                _c("div", { staticClass: "robotsBox" }, [
                  _c(
                    "div",
                    { staticClass: "robotsSearch" },
                    [
                      _c("span", { staticClass: "searchTips m-r-10" }, [
                        _vm._v("人员搜索"),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", size: "small" },
                        on: {
                          clear: function ($event) {
                            return _vm.getList()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getList()
                          },
                        },
                        model: {
                          value: _vm.search.robotNickName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.search,
                              "robotNickName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "search.robotNickName",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "m-l-10",
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.getList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "searchTips m-r-10",
                          staticStyle: { "margin-left": "30px" },
                        },
                        [_vm._v("随机选人")]
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "75px" },
                          attrs: {
                            clearable: "",
                            placeholder: "选择",
                            size: "small",
                          },
                          on: { change: _vm.randSelect },
                          model: {
                            value: _vm.randomlySelect,
                            callback: function ($$v) {
                              _vm.randomlySelect = $$v
                            },
                            expression: "randomlySelect",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "1位", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "2位", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "3位", value: 3 },
                          }),
                          _c("el-option", {
                            attrs: { label: "4位", value: 4 },
                          }),
                          _c("el-option", {
                            attrs: { label: "5位", value: 5 },
                          }),
                          _c("el-option", {
                            attrs: { label: "6位", value: 6 },
                          }),
                          _c("el-option", {
                            attrs: { label: "7位", value: 7 },
                          }),
                          _c("el-option", {
                            attrs: { label: "8位", value: 8 },
                          }),
                          _c("el-option", {
                            attrs: { label: "9位", value: 9 },
                          }),
                          _c("el-option", {
                            attrs: { label: "10位", value: 10 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "icon-list overflowOuto" },
                    [
                      _vm.list.length === 0
                        ? _c("div", { staticClass: "noData" }, [
                            _vm._v(" 暂无数据 "),
                          ])
                        : _c("virtualList", {
                            ref: "Virtual",
                            staticStyle: { width: "100%" },
                            attrs: {
                              "id-name": "robotSend",
                              "list-data": _vm.showlist,
                              "estimated-item-size": 36,
                            },
                            on: { load: _vm.getList },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "robotSendItemList" },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            key: _vm.list[item].robotId,
                                            attrs: {
                                              value: _vm.form.robots.includes(
                                                _vm.list[item].robotId
                                              ),
                                              disabled:
                                                _vm.form.robots.length >= 20 &&
                                                !_vm.form.robots.includes(
                                                  _vm.list[item].robotId
                                                ),
                                              label: _vm.list[item].robotId,
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.robotsClickFn(
                                                  _vm.list[item]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "robotNickName" },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "36px",
                                                    height: "36px",
                                                    "margin-right": "10px",
                                                    "border-radius": "50%",
                                                    "min-width": "36px",
                                                  },
                                                  attrs: {
                                                    src: _vm.list[item]
                                                      .robotHeadPic,
                                                  },
                                                }),
                                                _vm.renderRoleInfo(
                                                  _vm.list[item].robotId
                                                ).role
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "user_info_role",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.renderRoleInfo(
                                                              _vm.list[item]
                                                                .robotId
                                                            ).role
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("textShowMore", {
                                                  attrs: {
                                                    "line-clamp": 1,
                                                    text: _vm.list[item]
                                                      .robotNickName,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm.list.length > item + 1
                                          ? [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  key: _vm.list[item + 1]
                                                    .robotId,
                                                  attrs: {
                                                    value:
                                                      _vm.form.robots.includes(
                                                        _vm.list[item + 1]
                                                          .robotId
                                                      ),
                                                    disabled:
                                                      _vm.form.robots.length >=
                                                        20 &&
                                                      !_vm.form.robots.includes(
                                                        _vm.list[item + 1]
                                                          .robotId
                                                      ),
                                                    label:
                                                      _vm.list[item + 1]
                                                        .robotId,
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.robotsClickFn(
                                                        _vm.list[item + 1]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "robotNickName",
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        staticStyle: {
                                                          width: "36px",
                                                          height: "36px",
                                                          "margin-right":
                                                            "10px",
                                                          "border-radius":
                                                            "50%",
                                                          "min-width": "36px",
                                                        },
                                                        attrs: {
                                                          src: _vm.list[
                                                            item + 1
                                                          ].robotHeadPic,
                                                        },
                                                      }),
                                                      _vm.renderRoleInfo(
                                                        _vm.list[item + 1]
                                                          .robotId
                                                      ).role
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "user_info_role",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.renderRoleInfo(
                                                                    _vm.list[
                                                                      item + 1
                                                                    ].robotId
                                                                  ).role
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c("textShowMore", {
                                                        attrs: {
                                                          "line-clamp": 1,
                                                          text: _vm.list[
                                                            item + 1
                                                          ].robotNickName,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.list.length > item + 2
                                          ? [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  key: _vm.list[item + 2]
                                                    .robotId,
                                                  attrs: {
                                                    value:
                                                      _vm.form.robots.includes(
                                                        _vm.list[item + 2]
                                                          .robotId
                                                      ),
                                                    disabled:
                                                      _vm.form.robots.length >=
                                                        20 &&
                                                      !_vm.form.robots.includes(
                                                        _vm.list[item + 2]
                                                          .robotId
                                                      ),
                                                    label:
                                                      _vm.list[item + 2]
                                                        .robotId,
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.robotsClickFn(
                                                        _vm.list[item + 2]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "robotNickName",
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        staticStyle: {
                                                          width: "36px",
                                                          height: "36px",
                                                          "margin-right":
                                                            "10px",
                                                          "border-radius":
                                                            "50%",
                                                          "min-width": "36px",
                                                        },
                                                        attrs: {
                                                          src: _vm.list[
                                                            item + 2
                                                          ].robotHeadPic,
                                                        },
                                                      }),
                                                      _vm.renderRoleInfo(
                                                        _vm.list[item + 2]
                                                          .robotId
                                                      ).role
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "user_info_role",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.renderRoleInfo(
                                                                    _vm.list[
                                                                      item + 2
                                                                    ].robotId
                                                                  ).role
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c("textShowMore", {
                                                        attrs: {
                                                          "line-clamp": 1,
                                                          text: _vm.list[
                                                            item + 2
                                                          ].robotNickName,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                    ],
                    1
                  ),
                ]),
                _vm.robotsError
                  ? _c("div", { staticClass: "errorTips" }, [
                      _vm._v(" 请至少选择一个 "),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "消息类型", prop: "msgType" } },
                [
                  _c("msgSelect", {
                    attrs: { type: _vm.form.msgType },
                    on: {
                      "update:type": function ($event) {
                        return _vm.$set(_vm.form, "msgType", $event)
                      },
                      onChange: _vm.onhandleTypeChange,
                    },
                    model: {
                      value: _vm.form.msgContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "msgContent", $$v)
                      },
                      expression: "form.msgContent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.sure },
            },
            [_vm._v("发送")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.sure("close")
                },
              },
            },
            [_vm._v("发送并关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }